import VideoLectureDetails from '../../video-lectures/views/VideoLectureDetails';
import UploadVideoLecture from '../../video-lectures/views/UploadVideoLecture';
import EditVideoLecture from '../../video-lectures/views/EditVideoLecture';
import VideoCourseDetails from '../views/VideoCourseDetails';
import VideoCourseList from '../views/VideoCourseList';
import EditVideoCourse from '../views/EditVideoCourse';

const router = [
  {
    name: 'videoCourses.videoCourseList',
    path: '/video-courses',
    component: VideoCourseList,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoCourses.newVideoCourse',
    path: '/new-video-course',
    component: EditVideoCourse,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoCourses.videoCourseDetails',
    path: '/video-courses/:course_id',
    component: VideoCourseDetails,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoCourses.editVideoCourse',
    path: '/video-courses/:course_id/edit',
    component: EditVideoCourse,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoCourses.videoLectureDetails',
    path: '/video-courses/:course_id/lectures/:lecture_id',
    component: VideoLectureDetails,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoCourses.uploadVideoLecture',
    path: '/video-courses/:course_id/upload-video-lecture',
    component: UploadVideoLecture,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoCourses.newVideoLecture',
    path: '/video-courses/:course_id/new-video-lecture',
    component: EditVideoLecture,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'videoCourses.editVideoLecture',
    path: '/video-courses/:course_id/lectures/:lecture_id/edit',
    component: EditVideoLecture,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/video-courses/router/index.js